<template>
  <q-section :bg-i="uiMeta?.images?.showcaseBg[active]" :key="`showcase-bg-${active}`"
    v-bind="uiMeta?.layout?.wrapper?.containerWrapper">
    <q-section v-bind="uiMeta?.layout?.wrapper?.swiperWrapper" :key="props.active">
      <Swiper style="width: 100%; height: 100%" :modules="modules" v-bind="uiMeta?.config?.swiperOptions as any">
        <SwiperSlide v-for="item in showcaseListData?.[active]">
          <q-section v-bind="uiMeta?.layout?.wrapper?.itemWrapper" class="flex flex-col items-center">
            <q-section :bg-i="uiMeta?.images?.showcaseMask" p="relative" class="flex-noshrink">
              <q-section :bg-i="item.reward_icon" wh="90%" bg-p="center" bg-s="contain" bg-r="no-repeat"
                pc="pc"></q-section>
            </q-section>
            <q-section fs="12" :fc="uiMeta?.config?.nameColor" fw="400" p="relative" mt="3" class="text-center">
              {{ item.reward_name }}
            </q-section>
            <q-section fs="10" :fc="uiMeta?.config?.descColor" fw="400" p="relative" mt="3"
              class="text-center ws-nowrap">
              {{ item.reward_desc }}
            </q-section>
          </q-section>
        </SwiperSlide>
      </Swiper>
    </q-section>
    <q-section :bg-i="uiMeta?.images?.showcaseChipMask" v-bind="uiMeta?.layout?.wrapper?.chipWrapper">
      <q-section v-bind="uiMeta?.layout?.wrapper?.chipTextWrapper" class="text-center"
        :key="`chip-text-${props.active}-${myChildList?.[active]}`">
        {{ myChildList?.[active] }}
      </q-section>
    </q-section>
  </q-section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Autoplay } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import type { SwiperOptions } from 'swiper/types'
import { useShowcase } from './use-showcase'

// Swiper 模块列表
const modules = [Autoplay]

// 兼容两个tab
const props = defineProps({
  uiMeta: {
    type: Object,
    default: () => { },
  },
  active: {
    type: Number,
    default: 0,
  },
})

const { showcaseListData, myChildList } = useShowcase(props?.uiMeta)
</script>

<style scoped lang="scss"></style>
